import clsx from 'clsx';
import { Children, type CSSProperties, type ReactNode } from 'react';
import s from './ContentMarquee.module.scss';

type ContentMarqueeProps = {
  gap?: number;
  maxWidth?: string;
  duration?: number;
  mobileDuration?: number;
  children: ReactNode;
  className?: string;
};

export default function ContentMarquee({
  gap = 20,
  maxWidth = '320px',
  duration = 30,
  mobileDuration = duration,
  children,
  className,
}: ContentMarqueeProps) {
  const items = Children.toArray(children);

  if (items.length === 0) return null;

  const style = {
    '--marquee-gap': `${gap}px`,
    '--marquee-max-width': maxWidth,
    '--marquee-duration': `${duration}s`,
    '--marquee-mobile-duration': `${mobileDuration}s`,
  } as CSSProperties;

  return (
    <div className={clsx(s.content_marquee, className)} style={style}>
      <div className={s.content_marquee_track}>
        <div className={s.content_marquee_group}>
          {items.map((item, idx) => (
            <div key={`marquee-main-${idx}`} className={s.content_marquee_item}>
              {item}
            </div>
          ))}
        </div>
        <div className={s.content_marquee_group} aria-hidden="true">
          {items.map((item, idx) => (
            <div key={`marquee-copy-${idx}`} className={s.content_marquee_item}>
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
